import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@ludolio/shared-ui';
import { Clock } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/analytics')({
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Analytics</h1>
        <p className="text-muted-foreground mt-1">
          Detailed analytics and insights for your games.
        </p>
      </div>

      <Card>
        <CardHeader className="flex flex-row items-center gap-3">
          <Clock className="h-6 w-6 text-[hsl(var(--color-primary))]" />
          <CardTitle>Coming Soon</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            We are building a dedicated analytics dashboard with richer charts
            and exportable reports. In the meantime, game-level metrics are available on the
            <Link to="/dashboard" className="underline text-foreground"> Dashboard</Link> page.
          </p> 
        </CardContent>
      </Card>
    </div>
  );
}
